import React from 'react'
import "./content.css"
import Wikipedia from '../../components/Wikipedia/Wikipedia'
import { PlanetData, PlanetName } from '../../App'

interface InformationsProp {
  content: string, 
  source: string,
}

const Content = ({name, informations}:{name:PlanetName, informations:InformationsProp}) => { 

  return informations && (
    <article id='content'>
      <h2>{name}</h2>
      <p>{informations.content}</p>
      <Wikipedia linkToWiki={informations.source}/>
    </article>
  )
}

export default Content
